import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { AppContextProvider } from "./contexts/AppContextProvider";
import { BrowserRouter } from "react-router-dom";
import { Notifications } from "react-push-notification";

//css
import "./index.css";
import "@flaticon/flaticon-uicons/css/all/all.css";

import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <AppContextProvider>
        <React.Fragment>
            <BrowserRouter>
                <Notifications />
                <App />
                <ToastContainer />
            </BrowserRouter>
        </React.Fragment>
    </AppContextProvider>
);

serviceWorker.unregister();
